import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';
import { TariffOperator } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { operatorLogos } from '../../../channel-details/optimizer/configuration/utils/tariff-kind';
import {
  LogosDialogContent,
  LogosDialogGrid,
  LogosDialogButton,
  LogosDialogImage,
  LogosDialogName,
} from './logos-dialog.styled';

type LogosDialogProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  onOperatorSelect: (operator: TariffOperator) => void;
  currentOperator: TariffOperator | null;
};

export const LogosDialog: React.FC<LogosDialogProps> = ({ show, setShow, onOperatorSelect, currentOperator }) => {
  const { t } = useTranslation('dashboard');
  const { t: tc } = useTranslation('common');
  const [selectedOperator, setSelectedOperator] = useState<TariffOperator | null>(null);

  useEffect(() => {
    if (show && currentOperator) {
      setSelectedOperator(currentOperator);
    }
  }, [show]);

  const handleOperatorClick = (operator: TariffOperator) => {
    setSelectedOperator(operator);
  };

  const handleConfirm = () => {
    if (selectedOperator) {
      onOperatorSelect(selectedOperator);
      setShow(false);
      setSelectedOperator(null);
    }
  };

  const handleCancel = () => {
    setShow(false);
    setSelectedOperator(null);
  };

  return (
    <DialogConfirmation
      show={show}
      setShow={setShow}
      header={t('tariff.selectOperator')}
      primaryBtnText={tc('buttons.next')}
      secondaryBtnText={tc('buttons.cancel')}
      primaryBtnAction={handleConfirm}
      secondaryBtnAction={handleCancel}
      primaryBtnDisabled={!selectedOperator}
    >
      <LogosDialogContent>
        <LogosDialogGrid>
          {operatorLogos.map((logo) => (
            <LogosDialogButton
              key={logo.operator}
              selected={selectedOperator === logo.operator}
              onClick={() => handleOperatorClick(logo.operator)}
              variant="outlined"
            >
              <LogosDialogImage src={logo.imagePath} alt={logo.name} />
              <LogosDialogName>{logo.name}</LogosDialogName>
            </LogosDialogButton>
          ))}
        </LogosDialogGrid>
      </LogosDialogContent>
    </DialogConfirmation>
  );
};
